<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            @let kpi = kpis()[0];
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.userCount.title"
                        [body]="{
                            value: kpi.userCount,
                            precision: texts.userCount.precision,
                        }"
                        [badge]="{
                            value: kpi.userCountEvolution,
                            suffix: texts.userCount.badge.suffix,
                            precision: texts.userCount.badge.precision,
                            style: kpi.userCountEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.userCount.description.title"
                        [descriptionContent]="texts.userCount.description.content"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'userCount', 'userCountEvolution')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.consumption.title"
                        [body]="{
                            value: kpi.consumption,
                            precision: texts.consumption.precision,
                        }"
                        [badge]="{
                            value: kpi.consumptionEvolution,
                            suffix: texts.consumption.badge.suffix,
                            precision: texts.consumption.badge.precision,
                            style: kpi.consumptionEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.consumption.description.title"
                        [descriptionContent]="texts.consumption.description.content"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'consumption', 'consumptionEvolution')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.totalIncome.title"
                        [body]="{
                            value: kpi.totalIncome,
                            precision: texts.totalIncome.precision,
                        }"
                        [badge]="{
                            value: kpi.totalIncomeEvolution,
                            suffix: texts.totalIncome.badge.suffix,
                            precision: texts.totalIncome.badge.precision,
                            style: kpi.totalIncomeEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.totalIncome.description.title"
                        [descriptionContent]="texts.totalIncome.description.content"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'totalIncome', 'totalIncomeEvolution')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.userRate.title"
                        [body]="{
                            value: kpi.userRate,
                            precision: texts.userRate.precision,
                            suffix: texts.userRate.suffix,
                        }"
                        [badge]="{
                            value: kpi.userRateEvolution,
                            suffix: texts.userRate.badge.suffix,
                            precision: texts.userRate.badge.precision,
                            style: kpi.userRateEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.userRate.description.title"
                        [descriptionContent]="texts.userRate.description.content"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'userRate', 'userRateEvolution')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
            </div>

            <chart-card
                id="edfTrvUsersCountChart"
                [title]="texts.usersCountChart.title"
                [error]="usersCountChartError"
                [isLoading]="!usersCountChartData()[0].organizationId"
                [series]="usersCountChartSeries"
                [dataLabels]="usersCountDataLabels"
                [xaxisCategories]="usersCountXaxisCategories"
                [yaxis]="usersCountYaxis"
                [stacked]="true"
                [customTooltip]="usersCountCustomTooltip"
                [xaxisTitle]="texts.usersCountChart.xaxisTitle"
                [legend]="usersCountLegend"
                class="h-100">
            </chart-card>

            <div class="row">
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="edfTrvConsumptionsChart"
                        [title]="texts.consumptionsChart.title"
                        [error]="consumptionsChartError"
                        [isLoading]="!consumptionsChartData()[0].organizationId"
                        [series]="consumptionsChartSeries"
                        [dataLabels]="consumptionsDataLabels"
                        [xaxisCategories]="consumptionsXaxisCategories"
                        [yaxis]="consumptionsYaxis"
                        [stacked]="true"
                        [customTooltip]="consumptionsCustomTooltip"
                        [xaxisTitle]="texts.consumptionsChart.xaxisTitle"
                        [legend]="consumptionsLegend"
                        class="h-100">
                    </chart-card>
                </div>

                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="edfTrvMeanConsumptionsChart"
                        [title]="texts.meanConsumptionsChart.title"
                        [error]="meanConsumptionsChartError"
                        [isLoading]="!meanConsumptionsChartData()[0].organizationId"
                        [series]="meanConsumptionsChartSeries"
                        [dataLabels]="meanConsumptionsDataLabels"
                        [yaxis]="meanConsumptionsYaxis"
                        [xaxisTitle]="texts.meanConsumptionsChart.xaxisTitle"
                        [unitTooltip]="texts.meanConsumptionsChart.unitTooltip"
                        [yaxisPrecision]="texts.meanConsumptionsChart.yaxisPrecision"
                        class="h-100">
                    </chart-card>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="edfTrvIncomeChart"
                        [title]="texts.incomeChart.title"
                        [error]="incomeChartError"
                        [isLoading]="!incomeChartData()[0].organizationId"
                        [series]="incomeChartSeries"
                        [dataLabels]="incomeDataLabels"
                        [xaxisCategories]="incomeXaxisCategories"
                        [yaxis]="incomeYaxis"
                        [stacked]="true"
                        [precision]="texts.incomeChart.precision"
                        [xaxisTitle]="texts.incomeChart.xaxisTitle"
                        [customTooltip]="incomeCustomTooltip"
                        [legend]="incomeLegend"
                        class="h-100">
                    </chart-card>
                </div>

                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="edfTrvTariffChart"
                        [title]="texts.tariffChart.title"
                        [error]="tariffChartError"
                        [isLoading]="!tariffChartData()[0].organizationId"
                        [series]="tariffChartSeries"
                        [dataLabels]="tariffDataLabels"
                        [yaxis]="tariffYaxis"
                        [grid]="tariffGrid"
                        [precision]="texts.tariffChart.precision"
                        [xaxisTitle]="texts.tariffChart.xaxisTitle"
                        [unitTooltip]="texts.tariffChart.unitTooltip"
                        class="h-100">
                    </chart-card>
                </div>
            </div>
        </div>
    </div>
</div>
